/**
 * Check if an appointment is a in-person session
 * @param appointment
 */
export function isInPersonSession(appointment) {
  return (
    appointment.session_held_outside_of_orchid &&
    appointment.session_place_outside_of_orchid === "in-person"
  );
}
